module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dashboard-layout",
    class: {
      'has-top-strips': _vm.hasTopStrips,
      'trial-lockout-active': _vm.subscriptionLockoutActive
    },
    style: (_vm.hasTopStrips ? {
      '--strip-h': _vm.topStripHeight + 'px'
    } : null)
  }, [(_vm.verifyStripContent) ? _c('TrialStrip', {
    attrs: {
      "content": _vm.verifyStripContent,
      "offset-top": 0
    },
    on: {
      "cta": _vm.onVerifyStripCta
    }
  }) : _vm._e(), _vm._v(" "), (_vm.trialStripContent) ? _c('TrialStrip', {
    attrs: {
      "content": _vm.trialStripContent,
      "offset-top": _vm.hasVerifyStripVisible ? 40 : 0
    },
    on: {
      "dismiss": function($event) {
        _vm.trialStripDismissed = true
      },
      "cta": _vm.onTrialStripCta
    }
  }) : _vm._e(), _vm._v(" "), _c('TopNavbar', {
    attrs: {
      "lastUpdated": _vm.lastUpdated,
      "userEmail": _vm.$root.userEmail || ''
    }
  }, [_c('template', {
    slot: "filters"
  }, [_vm._t("navbarFilters")], 2)], 2), _vm._v(" "), _c('DashboardSidebar', {
    attrs: {
      "items": _vm.sidebarItems,
      "currentPath": _vm.$route.path,
      "disabled": !_vm.onboardingComplete
    },
    on: {
      "navigate": _vm.navigateTo
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "main-content"
  }, [_vm._t("default")], 2), _vm._v(" "), (_vm.cancelLockoutActive) ? _c('CanceledLockoutOverlay', {
    attrs: {
      "strip-offset-px": _vm.topStripHeight
    }
  }) : (_vm.pastDueLockoutActive && !_vm.billingPaymentModalFlowActive) ? _c('PastDueLockoutOverlay', {
    attrs: {
      "strip-offset-px": _vm.topStripHeight
    }
  }) : (_vm.trialLockoutActive) ? _c('TrialLockoutOverlay', {
    attrs: {
      "strip-offset-px": _vm.topStripHeight
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-14e48463!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/buybox/DashboardLayout.vue
// module id = 728
// module chunks = 2